import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { IBlockedDatesResponse } from "../../@types/blockedDates";

export const GetODPLimitBlockedDatesApiService =
  async (): Promise<IBlockedDatesResponse> => {
    const url = `/odp_limits/blocked_dates/`;

    const { data } = await axios.get(`${url}`);

    return data;
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetODPLimitBlockedDatesApiService = () =>
  useQuery<Promise<IBlockedDatesResponse>, AxiosError, IBlockedDatesResponse>(
    ["GetODPLimitBlockedDatesApiService"],
    () => GetODPLimitBlockedDatesApiService(),
    { keepPreviousData: false }
  );

export default useGetODPLimitBlockedDatesApiService;
